import React, { useState } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Gallery } from "../components/Gallery";
import { Services } from "../components/Services";
import { WhyChooseUs } from "../components/WhyChooseUs";
import { About } from "../components/About";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { Toaster } from "../components/ui/sonner";
import { EstimateModal } from "../components/EstimateModal";

export const Home = () => {
  const [isEstimateModalOpen, setIsEstimateModalOpen] = useState(false);

  const openEstimateModal = () => {
    setIsEstimateModalOpen(true);
  };

  const closeEstimateModal = () => {
    setIsEstimateModalOpen(false);
  };

  return (
    <div className="min-h-screen">
      <Header onOpenEstimateModal={openEstimateModal} />

      <main>
        <Hero onOpenEstimateModal={openEstimateModal} />
        <Gallery />
        <Services />
        <WhyChooseUs />
        <About />
        <Contact />
      </main>

      <Footer />
      <Toaster />

      <EstimateModal
        isOpen={isEstimateModalOpen}
        onClose={closeEstimateModal}
      />
    </div>
  );
};

export default Home;
